import { registerAction } from '../../Action'

const SET_PRESENTATION_ID = 'SET_PRESENTATION_ID'

const reducer = (state = {}, action) => {
  const presentationId = action.payload
  return {
    ...state,
    presentationId,
  }
}

const setPresentationId = registerAction(SET_PRESENTATION_ID, { reducer })

export default setPresentationId
